export enum MARKETING_PREFERENCE_OPTIONS {
  SMS = 'isOptedInToSms',
  MARKETING = 'isOptedInToMarketing',
  PLUMBING_OFFER = 'isOptedInToPlumbingOffer',
}
